export default "__VITE_ASSET__DKSkV9eo__"